import { Box, CircularProgress, Grid, Typography } from '@mui/material';

export function GraphLoadingSpinner() {
    return (
        <Grid xs={12} item display="flex" alignContent={'space-between'} mb={'3rem'}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress width='100%' size={80} />
                <div>Loading Bar Graph...</div>
            </Box>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress width='100%' alignContent='center' size={80} />
                <div>Loading Pie Chart...</div>
            </Box>
        </Grid>
    )
}

export function TableLoadingSpinner({ tableTitle }) {
    return (
        <Box sx={{ width: '100%', height: 500, display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress width='100%' size={80} />
            <div>Loading {tableTitle}...</div>
        </Box>
    )
}

export function DashboardEmissionsSpinner() {
    return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 250, display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress width='100%' size={80} />
            <Typography>Loading Emissions Table...</Typography>
        </Box>
    )
}


export function FertilizerLoadingSpinner() {
    return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 600, display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress width='100%' size={80} />
            <Typography>Loading Fertilizers Applied...</Typography>
        </Box>
    )
}


export function AgrochemicalLoadingSpinner() {
    return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 600, display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress width='100%' size={80} />
            <Typography>Loading Agrochemicals Applied...</Typography>
        </Box>
    )
}


export function DataCapturingTableLoadingSpinner({ month }) {
    return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 600, display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress width='100%' size={80} />
            <Typography>Loading Data Capturing Information for {month}...</Typography>
        </Box>
    )
}